import { styled } from "@pigment-css/react";
import { ActionPill } from "@acto/taskpane/field-sales-2/components/primitives/ActionPill";

/** Segmented header action pill: `ActionPillButton` segments in one glass capsule at fixed icon centres. */
export const HeaderActionPill = styled(ActionPill)(({ theme }) => ({
  padding: `0 ${theme.fieldSalesTwo.spacing[10]}`,
  gap: 0,
}));
